import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {AuthService} from '../../../auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  UserData = new FormGroup({
    email: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    remember: new FormControl('')
  });

  private errorSub: Subscription;
  message;
  rememberChecked;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthService
  ) {
  }

  ngOnInit(): void {

  }


  onSubmit(): any {
    this.rememberChecked = this.UserData.value.remember === true;
    this.UserData.patchValue({remember: this.rememberChecked});
    this.auth.login(this.UserData.value);
    console.log(this.UserData.value);

    this.errorSub = this.auth.getErrorListerner().subscribe(res => {
      this.message = res.message;
    });


  }


}
